<template>
  <div class="question8">
    <div class="header">
      <img src="../assets/head.jpeg">
    </div>

    <div class="body">
      <div>
        <p class="title">这是虚拟病例并非真实患者</p>
        <p
          class="content"
        >李某，女，79岁，于16:30家人发现其发现意识不清，呼之能应，无大小便失禁，无发热、无口角歪斜，遂于我院急诊就诊，约18:00测血糖3.3mmol/L，予50%葡萄糖注射液40ml静推，20分钟后神志转清，复测血糖5.4mmol/L，为进一步诊治，收治我科。入院当天患者早餐进食少，午餐未进食，格列美脲未停药。1年前因滑倒以“腰椎压缩性骨折”收入我院骨科行保守治疗。20年前发现血糖升高，起始口服二甲双胍治疗，8年前加用格列美脲(4mg qd)治疗。既往无低血糖发作史。高血压病史20年，平素服用氯沙坦治疗。8年前脑梗发作，未留有明显后遗症，无特殊用药。COPD 14年，平素不规律使用异丙托溴铵气雾剂。</p>
        <p class="content">T:36.8 °C，P: 76 次/分 ，R: 18 次/分 ，BP:140/90 mmHg</p>
        <p
          class="content"
        >查体:神志清，精神萎靡，营养中等，发育良好，体型偏瘦，平车推入病房，无明显脱水貌，全身皮肤粘膜无黄染，无淤斑，未扪及浅表淋巴结肿大。胸廓前后径增大，双肺呼吸音减弱，呼气延长，可闻及散在湿性啰音，心率 76 次/分，律齐，无病理性杂音。</p>
        <p class="content">
          实验室检查:Hb 89g/L，WBC 8.07×10
          <sup>9</sup>/L，N 0.76，L 0.35，PLT 269×10
          <sup>9</sup>/L;血糖3.3mmol/L， 尿蛋白及酮体阴性，ALT 14u/L，AST 17.8 u/L , BUN 11.2 mmol/L , Cr 126umol/L，UA 466 umol/L，尿微量白蛋白40.3mmol /L。头颅CT示右侧基底节区陈旧性腔梗。胸片显示双肺纹理增多、紊乱，双肺呈桶状，心影狭长。心电图显示T波改变。
        </p>
      </div>

      <div class="q">
        <van-row class="q_title">1. 您为该患者制定的新的糖化血红蛋白控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q1">
          <van-radio name="A">A. ≤6.5-7.0%</van-radio>
          <van-radio name="B">B. >7.0-8.0%</van-radio>
          <van-radio name="C">C. <7.5-8.0%</van-radio>
          <van-radio name="D">D. >8.0-8.5%</van-radio>
          <van-radio name="E">
            <van-field v-model="q1_E" label-align="left" class="other" label="E. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">2. 您为该患者制定的新的空腹/餐前血糖控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q2">
          <van-radio name="A">A. 6.0-7.8mmol/L</van-radio>
          <van-radio name="B">B. 7.5-8.5mmol/L</van-radio>
          <van-radio name="C">C. 5.6-10.0mmol/L</van-radio>
          <van-radio name="D">
            <van-field v-model="q2_D" label-align="left" class="other" label="D. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">3. 您为该患者制定的新的餐后 2 小时血糖控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q3">
          <van-radio name="A">A. 5.0-8.3mmol/L</van-radio>
          <van-radio name="B">B. 5.6-10.5mmol/L</van-radio>
          <van-radio name="C">C. 11.1-13.9 mmol/L</van-radio>
          <van-radio name="D">
            <van-field v-model="q3_D" label-align="left" class="other" label="D. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">4. 根据患者情况，您将为该患者制定的降糖药物数量可能为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q4">
          <van-radio name="A">A. 1 种</van-radio>
          <van-radio name="B">B. 2 种</van-radio>
          <van-radio name="C">C. 3 种</van-radio>
          <van-radio name="D">D. 3 种以上</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">5. 您会选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q5">
          <van-radio name="A">A. 单用药物</van-radio>
          <van-radio name="B">B. 联用药物</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">6. 若您选择单用药物，您选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q6">
          <van-radio name="A">A. α-糖苷酶抑制剂</van-radio>
          <van-radio name="B">B. 双胍类</van-radio>
          <van-radio name="C">C. 格列奈类</van-radio>
          <van-radio name="D">D. DPP-4 抑制剂</van-radio>
          <van-radio name="E">E. 格列酮类</van-radio>
          <van-radio name="F">F. GLP-1 受体激动剂</van-radio>
          <van-radio name="G">G. 胰岛素</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">7. 若您选择联用药物，您选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q7">
          <van-checkbox name="A" shape="square">A. α-糖苷酶抑制剂</van-checkbox>
          <van-checkbox name="B" shape="square">B. 双胍类</van-checkbox>
          <van-checkbox name="C" shape="square">C. 格列奈类</van-checkbox>
          <van-checkbox name="D" shape="square">D. 磺脲类</van-checkbox>
          <van-checkbox name="E" shape="square">E. DPP-4 抑制剂</van-checkbox>
          <van-checkbox name="F" shape="square">F. 格列酮类</van-checkbox>
          <van-checkbox name="G" shape="square">G. GLP-1 受体激动剂</van-checkbox>
          <van-checkbox name="H" shape="square">H. 胰岛素</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">8. 以下说法错误的是</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q8">
          <van-checkbox name="A" shape="square">A. 2018 AACE/ACE 指南推荐 DDP-4 抑制剂作为 2 型糖尿病的一线及全程治疗药物</van-checkbox>
          <van-checkbox name="B" shape="square">B. DDP-4 抑制剂获批可用于糖尿病前期适应证</van-checkbox>
          <van-checkbox name="C" shape="square">C. DDP-4 抑制剂会增加主要心血管复合终点的风险</van-checkbox>
          <van-checkbox name="D" shape="square">D. 以上都不正确</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">9. 请问您认为应该为该患者制定哪些合并症的控制计划?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q9">
          <van-checkbox name="A" shape="square">A. 控制血压</van-checkbox>
          <van-checkbox name="B" shape="square">B. 预防心血管疾病发生</van-checkbox>
          <van-checkbox name="C" shape="square">C. 预防认知功能障碍</van-checkbox>
          <van-checkbox name="D" shape="square">D. 预防外周血管疾病</van-checkbox>
          <van-checkbox name="E" shape="square">E. 预防眼底病变</van-checkbox>
          <van-checkbox name="F" shape="square">
            <van-field
              v-model="q9_F"
              label-align="left"
              v-on:click.stop="stopCheck()"
              class="other"
              label="F. 其他，请注明"
            />
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">10. 根据您的评估，该患者合并疾病的严重程度如何?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q10">
          <van-radio name="A">A. 轻度</van-radio>
          <van-radio name="B">B. 中度</van-radio>
          <van-radio name="C">C. 重度/终末期</van-radio>
          <van-radio name="D">D. 未做相关评估</van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">11. 请问当您为该老年糖尿病患者(≥60岁)选择降糖药物时，您会重点关注哪些方面?(可多选)每个选项后面(重要程度1-7分)</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q11" @change="q11_change">
          <van-checkbox name="A" shape="square">
            A. 有效降低FPG/PPG
            <span class="pingfeng" v-show="q11_a_show">
              程度:
              <select class="shortselect" v-model="q11_A" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="B" shape="square">
            B. 有效降低HbA1c
            <span class="pingfeng" v-show="q11_b_show">
              程度:
              <select class="shortselect" v-model="q11_B" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="C" shape="square">
            C. 平稳降糖
            <span class="pingfeng" v-show="q11_c_show">
              程度:
              <select class="shortselect" v-model="q11_C" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="D" shape="square">
            D. 低血糖风险小
            <span class="pingfeng" v-show="q11_d_show">
              程度:
              <select class="shortselect" v-model="q11_D" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="E" shape="square">
            E. 药物间相互作用少
            <span class="pingfeng" v-show="q11_e_show">
              程度:
              <select class="shortselect" v-model="q11_E" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="F" shape="square">
            F. 一天一次，服用方便
            <span class="pingfeng" v-show="q11_f_show">
              程度:
              <select class="shortselect" v-model="q11_F" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="G" shape="square">
            G. 不增加体重
            <span class="pingfeng" v-show="q11_g_show">
              程度:
              <select class="shortselect" v-model="q11_G" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="H" shape="square">
            H. 不增加心血管疾病风险
            <span class="pingfeng" v-show="q11_h_show">
              程度:
              <select class="shortselect" v-model="q11_H" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="I" shape="square">
            I. 不增加骨折风险
            <span class="pingfeng" v-show="q11_i_show">
              程度:
              <select class="shortselect" v-model="q11_I" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="J" shape="square">
            J. 对胃肠道的影响小
            <span class="pingfeng" v-show="q11_j_show">
              程度:
              <select class="shortselect" v-model="q11_J" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="K" shape="square">
            K. 对肝功能影响小
            <span class="pingfeng" v-show="q11_k_show">
              程度:
              <select class="shortselect" v-model="q11_K" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="L" shape="square">
            L. 对肾功能影响小
            <span class="pingfeng" v-show="q11_l_show">
              程度:
              <select class="shortselect" v-model="q11_L" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
          <van-checkbox name="M" shape="square">
            M. 指南推荐，适合老年糖尿病患者(≥60岁)
            <span class="pingfeng" v-show="q11_m_show">
              程度:
              <select class="shortselect" v-model="q11_M" v-on:click.stop="stopCheck()">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </span>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">12. 该患者入院治疗3天后，出现血糖反弹，空腹血糖达10mmol/L，经治医生加用了DPP-4抑制剂， 可能考虑的主要因素是什么?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q12">
          <van-checkbox name="A" shape="square">A. 有效降低 FPG/PPG</van-checkbox>
          <van-checkbox name="B" shape="square">B. 有效降低 HbA1c</van-checkbox>
          <van-checkbox name="C" shape="square">C. 平稳降糖</van-checkbox>
          <van-checkbox name="D" shape="square">D. 低血糖风险小</van-checkbox>
          <van-checkbox name="E" shape="square">E. 药物间相互作用少</van-checkbox>
          <van-checkbox name="F" shape="square">F. 一天一次，服用方便，可提高依从性</van-checkbox>
          <van-checkbox name="G" shape="square">G. 不增加心血管疾病风险</van-checkbox>
          <van-checkbox name="H" shape="square">H. 不增加骨折风险</van-checkbox>
          <van-checkbox name="I" shape="square">I. 对胃肠道的影响小</van-checkbox>
          <van-checkbox name="J" shape="square">J. 对肝功能影响小</van-checkbox>
          <van-checkbox name="K" shape="square">K. 对肾功能影响小</van-checkbox>
          <van-checkbox name="L" shape="square">L. 指南推荐，适合老年糖尿病患者(≥60 岁)</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">13. 请问您为该患者设置的综合生活质量改善目标有哪些?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q13">
          <van-checkbox name="A" shape="square">A. 改善认知功能</van-checkbox>
          <van-checkbox name="B" shape="square">B. 提高日常活动能力</van-checkbox>
          <van-checkbox name="C" shape="square">C. 降低跌倒风险</van-checkbox>
          <van-checkbox name="D" shape="square">D. 降低骨折风险</van-checkbox>
          <van-checkbox name="E" shape="square">E. 减少服药种类，减少过度治疗</van-checkbox>
          <van-checkbox name="F" shape="square">F. 减少日服药次数，提高依从性</van-checkbox>
          <van-checkbox name="G" shape="square">G. 避免对胃肠道的影响</van-checkbox>
          <van-checkbox name="H" shape="square">H. 避免药物对肝肾功能的影响</van-checkbox>
          <van-checkbox name="I" shape="square">
            <van-field
              v-model="q13_I"
              label-align="left"
              v-on:click.stop="stopCheck()"
              class="other"
              label="I. 其他，请注明"
            />
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="apply">
        <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
// import validator from '@/utils/validator.js'
import Cookies from "js-cookie";

export default {
  name: "Question8",
  data() {
    return {
      q1: [],
      q2: [],
      q3: [],
      q4: [],
      q5: [],
      q6: [],
      q7: [],
      q8: [],
      q9: [],
      q10: [],
      q11: [],
      q12: [],
      q13: [],

      q1_E: "",
      q2_D: "",
      q3_D: "",
      q9_F: "",
      q13_I: "",
      periods: 1,
      q11_a_show: false,
      q11_b_show: false,
      q11_c_show: false,
      q11_d_show: false,
      q11_e_show: false,
      q11_f_show: false,
      q11_g_show: false,
      q11_h_show: false,
      q11_i_show: false,
      q11_j_show: false,
      q11_k_show: false,

      q11_l_show: false,
      q11_m_show: false,

      q11_A: 1,

      q11_B: 1,

      q11_C: 1,

      q11_D: 1,

      q11_E: 1,

      q11_F: 1,

      q11_G: 1,

      q11_H: 1,
      q11_I: 1,

      q11_J: 1,

      q11_K: 1,
      q11_L: 1,
      q11_M: 1,
       isSubmit: false,
    };
  },

  methods: {
    q11_change() {
      if (this.q11.includes("A")) {
        this.q11_a_show = true;
      } else {
        this.q11_a_show = false;
      }
      if (this.q11.includes("B")) {
        this.q11_b_show = true;
      } else {
        this.q11_b_show = false;
      }
      if (this.q11.includes("C")) {
        this.q11_c_show = true;
      } else {
        this.q11_c_show = false;
      }
      if (this.q11.includes("D")) {
        this.q11_d_show = true;
      } else {
        this.q11_d_show = false;
      }
      if (this.q11.includes("E")) {
        this.q11_e_show = true;
      } else {
        this.q11_e_show = false;
      }
      if (this.q11.includes("F")) {
        this.q11_f_show = true;
      } else {
        this.q11_f_show = false;
      }
      if (this.q11.includes("G")) {
        this.q11_g_show = true;
      } else {
        this.q11_g_show = false;
      }
      if (this.q11.includes("H")) {
        this.q11_h_show = true;
      } else {
        this.q11_h_show = false;
      }
      if (this.q11.includes("I")) {
        this.q11_i_show = true;
      } else {
        this.q11_i_show = false;
      }
      if (this.q11.includes("J")) {
        this.q11_j_show = true;
      } else {
        this.q11_j_show = false;
      }
      if (this.q11.includes("K")) {
        this.q11_k_show = true;
      } else {
        this.q11_k_show = false;
      }
      if (this.q11.includes("L")) {
        this.q11_l_show = true;
      } else {
        this.q11_l_show = false;
      }
      if (this.q11.includes("M")) {
        this.q11_m_show = true;
      } else {
        this.q11_m_show = false;
      }
    },
    // 阻止点击输入引起checkbox 选中变好
    stopCheck() {
      return false;
    },
    // 判断是否答题
    isAnswer(q, answer) {
      if (answer.length == 0) {
        this.$dialog.alert({
          message: "第" + q + "题没有选择"
        });
        return false;
      }
      return true;
    },
    // 弹框
    customAlert(msg) {
      this.$dialog.alert({
        message: msg
      });
      return;
    },
    // 弹框 确定后返回列表
    customAlert2(msg) {
      this.$dialog
        .alert({
          message: msg
        })
        .then(() => {
          this.$router.go(-1); //返回上一层
        });
      return;
    },

    // 组织数据11 题答案
    organizationQ11(){
      let tmp = [] ;
      if (this.q11.includes("A")) {
        tmp.push('A:'+ this.q11_A);
      }
      if (this.q11.includes("B")) {
        tmp.push('B:'+ this.q11_B);
      }
      if (this.q11.includes("C")) {
        tmp.push('C:'+ this.q11_C);
      }
      if (this.q11.includes("D")) {
        tmp.push('D:'+ this.q11_D);
      }
      if (this.q11.includes("E")) {
        tmp.push('E:'+ this.q11_E);
      }
      if (this.q11.includes("F")) {
        tmp.push('F:'+ this.q11_F);
      }
      if (this.q11.includes("G")) {
        tmp.push('G:'+ this.q11_G);
      }
      if (this.q11.includes("H")) {
        tmp.push('H:'+ this.q11_H);
      }
      if (this.q11.includes("I")) {
        tmp.push('I:'+ this.q11_I);
      }
      if (this.q11.includes("J")) {
        tmp.push('J:'+ this.q11_J);
      }
      if (this.q11.includes("K")) {
        tmp.push('K:'+ this.q11_K);
      }
      if (this.q11.includes("L")) {
        tmp.push('L:'+ this.q11_L);
      }
      if (this.q11.includes("M")) {
        tmp.push('M:'+ this.q11_M);
      }
      return tmp;
    },
    // 提交数据
    submit() {
      if(this.isSubmit){
        this.customAlert('正在提交')
        return false
      }
      this.isSubmit = true
      // 去除空格
      this.q1_E = this.q1_E.trim();
      this.q2_D = this.q2_D.trim();
      this.q3_D = this.q3_D.trim();
      this.q9_F = this.q9_F.trim();
      this.q13_I = this.q13_I.trim();

      // 判断是否楼选
      const a1 = this.isAnswer(1, this.q1);
      const a2 = this.isAnswer(2, this.q2);
      const a3 = this.isAnswer(3, this.q3);
      const a4 = this.isAnswer(4, this.q4);
      const a5 = this.isAnswer(5, this.q5);
      const a6 = this.isAnswer(6, this.q6);
      const a7 = this.isAnswer(7, this.q7);
      const a8 = this.isAnswer(8, this.q8);
      const a9 = this.isAnswer(9, this.q9);
      const a10 = this.isAnswer(10, this.q10);
      const a11 = this.isAnswer(11, this.q11);
      const a12 = this.isAnswer(12, this.q12);
      const a13 = this.isAnswer(13, this.q13);

      // 判断是否选了其他，但是还没填其他
      if (a1 && this.q1.includes("E") && this.q1_E.length == 0) {
        this.$dialog.alert({
          message: "请把第1题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a2 && this.q2.includes("D") && this.q2_D.length == 0) {
        this.$dialog.alert({
          message: "请把第2题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a3 && this.q3.includes("D") && this.q3_D.length == 0) {
        this.$dialog.alert({
          message: "请把第3题的其他的内容也填写一下"
        });
        this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a9 && this.q9.includes("F") && this.q9_F.length == 0) {
        this.$dialog.alert({
          message: "请把第9题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      // 判断是否选了其他，但是还没填其他
      if (a13 && this.q13.includes("I") && this.q13_I.length == 0) {
        this.$dialog.alert({
          message: "请把第13题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }
      if (
        !(
          a1 &&
          a2 &&
          a3 &&
          a4 &&
          a5 &&
          a6 &&
          a7 &&
          a8 &&
          a9 &&
          a10 &&
          a11 &&
          a12 &&
          a13
        )
      ) {
         this.isSubmit = false
        return;
      }
      // 提交数据
      let data = {};
      data.uid = Cookies.get("uid");
      data.question = 8;
      data.periods = this.periods;
      let answer = {};
      answer.q1 = this.q1;
      answer.q2 = this.q2;
      answer.q3 = this.q3;
      answer.q4 = this.q4;
      answer.q5 = this.q5;
      answer.q6 = this.q6;
      answer.q7 = this.q7;
      answer.q8 = this.q8;
      answer.q9 = this.q9;
      answer.q10 = this.q10;
      answer.q11 = this.organizationQ11();
      answer.q12 = this.q12;
      answer.q13 = this.q13;
      answer.q1_E = this.q1_E;
      answer.q2_D = this.q2_D;
      answer.q3_D = this.q3_D;
      answer.q9_F = this.q9_F;
      answer.q13_I = this.q13_I;

      data.answer = answer;
      Http.post(api.answer, data).then(response => {
         this.isSubmit = false
        if (response.code == 1) {
          // 提交成功
          this.customAlert2("提交成功");
          return false;
        } else {
          // 发送失败
          this.customAlert(response.msg);
          return false;
        }
      });
      return false;
    }
  },
  mounted: function() {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.periods = this.$route.query.periods;
  }
};
</script>

<style lang="less">
.question8 {
  font-size: 16px;
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .pingfeng {
    color: #0d94ff;
  }
  .shortselect {
    background: #fafdfe;
    height: 20px;
    width: 40px;
    line-height: 20px;
    border: 1px solid #9bc0dd;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
  }
  .van-cell {
    font-size: 16px;
  }
  .van-col {
    margin-bottom: 20px;
  }
  .van-field__body {
    border-bottom: 2px solid #f7f7f7;
  }
  .van-field__label {
    width: 120px;
  }
  .clear {
    clear: both;
  }
  .van-radio {
    margin: 12px;
  }
  .van-checkbox {
    margin-left: 12px;
  }
  .van-checkbox__label {
    margin: 12px;
    text-align: left;
  }
  .margin-right-12 {
    margin-right: 12px;
  }
  .margin-bottom-12 {
    margin-bottom: 12px;
  }
  table,
  th,
  td {
    border: 1px solid black;
  }

  .other {
    padding: 0px;
    text-align: left;
  }
  .body {
    //margin-top: .5rem;
    .title {
      text-align: center;
      font-size: 24px;
    }
    .content {
      margin: 12px;
      text-indent: 34px;
    }
    .q {
      margin-left: 16px;
      margin-right: 12px;
      .q_title {
        float: left;
        text-align: left;
      }
    }
    .apply {
      text-align: center;
      &_title {
        font-size: 18px;
        width: 50%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question8.vue